import { render } from "./BevarageView.vue?vue&type=template&id=0ac79460"
import script from "./BevarageView.vue?vue&type=script&lang=js"
export * from "./BevarageView.vue?vue&type=script&lang=js"

import "./BevarageView.vue?vue&type=style&index=0&id=0ac79460&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vuemasi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__